export const environment = Object.freeze({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api/v1",
});

